/** Bimbingan-session live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { BimbinganSessionDoc } from '../../types';

export function useSessions(skripsiId: string | null) {
  return useLiveQuery<BimbinganSessionDoc>(
    skripsiId ? COL.sessions : null,
    skripsiId ? [where('skripsiId', '==', skripsiId), orderBy('sessionDate', 'desc')] : [],
    Boolean(skripsiId),
  );
}

export function useDosenSessions(dosenId: string | null) {
  return useLiveQuery<BimbinganSessionDoc>(
    dosenId ? COL.sessions : null,
    dosenId ? [where('dosenId', '==', dosenId), orderBy('sessionDate', 'desc')] : [],
    Boolean(dosenId),
  );
}
